import React from "react";
import { compose } from "redux";

import connectActions from "fantastic/lib/connectActions";
import connectProps from "fantastic/lib/connectProps"
import sectionsOperations from "fantastic/lib/sections"

import cloneId from "fantastic/actions/cloneId";
import favoriteId from "fantastic/actions/favoriteId";
import removeId from "fantastic/actions/removeId";
import editId from "fantastic/actions/editId";

import getSelected from "fantastic/selectors/getSelected";
import setSelected from "fantastic/actions/setSelected";

const ClickTools = ({
  cloneId,
  removeId,
  favoriteId,
  editId,
  top,
  left,
  selected,
  setSelected,
  sections
}) => {
  if (!selected) return null;

  const getSelectedNode = () => {
    return sectionsOperations.byId(selected, sections);
  };

  const selectedNode = getSelectedNode();
  if (!selectedNode) return null;

  const meta = selectedNode.meta

  const style = {
    position: 'fixed',
    top: `${top}px`,
    left: `${left}px`,
    zIndex: '1000'
  }

  const cloneWrap = () => {
    cloneId(selectedNode.id)
    setSelected(selectedNode.id)
  }

  return (
    <div id='clickMenuTool' style={style}>
      <div className='click-tool-menu'>
        <div className='click-tool-menu__header'>
          {meta.name}
        </div>
        { meta.favoritable && (
          <div className='click-tool-menu__list' onClick={() => favoriteId(selectedNode.id)}>
            <div className='click-tool-menu__item'>
              <i className="fa fa-star-o" style={{fontSize: '18px'}} />
            </div>
            <div className='click-tool-menu__item'>
              { i18n.t('favorite') }
            </div>
          </div>
        )}
        { meta.removable && (
          <>
            <div className='click-tool-menu__list' onClick={() => cloneWrap()}>
              <div className='click-tool-menu__item'>
                <i className="fa fa-clone"/>
              </div>
              <div className='click-tool-menu__item'>
                { i18n.t('clone') }
              </div>
            </div> 
            <div className='click-tool-menu__list' onClick={() => removeId(selectedNode.id)}>
              <div className='click-tool-menu__item'>
                <i className="fa fa-trash-o" style={{fontSize: '19px'}} />
              </div>
              <div className='click-tool-menu__item'>
                { i18n.t('remove') }
              </div>
            </div>
          </>
        )}
        { meta.editable && (
          <div className='click-tool-menu__list' onClick={() => editId(selectedNode.id)}>
            <div className='click-tool-menu__item'>
              <i className="fa fa-pencil" />
            </div>
            <div className='click-tool-menu__item'>
              { i18n.t('edit') }
            </div>
          </div>
        )}
        <div className='click-tool-menu__footer'/>
      </div>
    </div>
  );
};

export default compose(
  connectActions({ cloneId, removeId, favoriteId, editId, setSelected }),
  connectProps({ selected: getSelected}, 'sections')
)(ClickTools);
